import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    detail: {
        url: `${customerApi}/api/customers/{id}/detail`,
        type: 'GET',
    },
    followUsers: {
        url: `${customerApi}/api/duplicated_customers/{external_userid}/follow_users`,
        type: 'GET',
    },
    customerChats: {
        url: `${customerApi}/api/group_chat/customer_chats`,
        type: 'GET',
    },
}
